interface LiveJsonPreviewProps {
  data: Record<string, unknown>
  label?: string
}

export function LiveJsonPreview({ data, label = "Policy JSON Preview" }: LiveJsonPreviewProps) {
  return (
    <div className="space-y-1.5">
      <p className="text-sm font-medium text-muted-foreground">{label}</p>
      <div className="rounded-md border bg-muted/50 overflow-auto max-h-64">
        <pre className="p-3 text-xs font-mono text-foreground whitespace-pre">
          {JSON.stringify(data, null, 2)}
        </pre>
      </div>
    </div>
  )
}
